import { useEffect } from "react";

export function useChangeHandler<T extends string | number | string[]>(
  selector: string,
  onChange: (value: T) => void
): void {
  useEffect(() => {
    window.$(document).on("change", selector, () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onChange(<any>window.$(selector).val());
    });
    return () => {
      window.$(document).off("change", selector);
    };
  });
}
